export class RecipientCategoryDto {
    merchant_id: string
    category: string
}

export class RecipientDto {
    merchant_id: string
    name: string
    card_num: string
    wallet: string
    country_code: string
    scheme_code: string
    payment_type: string
    category_id: string
    src_name: string
    amount: string
    description?: string
    bank: {
        bank_name: string
        bank_code: string
        country_code: string
        account_no: string
        sort_code: string
        route_no: string
    }
}

export class RecipientBulkDto {
    merchant_id: string
    name: string
    card_num: string
    wallet: string
    country_code: string
    scheme_code: string
    payment_type: string
    category_id: string
    amount: string
    description?: string
    beneficiary_name: string
    src_name: string
    currency_code: string
    bank: {
        bank_name: string
        bank_code: string
        country_code: string
        account_no: string
        sort_code: string
        route_no: string
    }
}

export class EditRecipientDto {
    product_id: string
    merchant_id: string
    name: string
    card_num: string
    wallet: string
    country_code: string
    scheme_code: string
    payment_type: string
    category_id: string
    amount: string
    description?: string
    bank: {
        bank_name: string
        bank_code: string
        country_code: string
        account_no: string
        sort_code: string
        route_no: string
    }
}

export class UpdateTransactionStatusDto {
    failed_recipients: [
        {
            product_id: string
        }
    ]
}
